// Central content for Mysore Paper Suppliers Corporation

export const CONTACT = {
  company: "Mysore Paper Suppliers Corporation",
  person: "Milan Jain",
  phoneMobile: "+91 88672 59550",
  phoneMobileRaw: "918867259550",
  phoneLine: "080 - 4122 3371",
  phoneLineRaw: "08041223371",
  email: "mysorepaper@gmail.com",
  address: ["No. 5, Srinath Building,", "Sultanpet Circle,", "Bangalore - 560 053."],
  hours: "Mon – Sat · 10:00 AM – 7:00 PM",
  whatsapp: "https://wa.me/918867259550?text=Hello%20Mysore%20Paper%2C%20I%20would%20like%20to%20enquire%20about%20paper%20%26%20board%20supply.",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Mills", to: "/mills" },
  { label: "Industries", to: "/industries" },
  { label: "Sustainability", to: "/sustainability" },
  { label: "Contact", to: "/contact" },
];

export const TRUST_STRIP = [
  { value: "1970", label: "Serving the trade since" },
  { value: "3", label: "Generations of trust" },
  { value: "4+", label: "Trusted mill associations" },
  { value: "B2B", label: "Supply-focused partner" },
];

const IMG_SHEETS = "https://images.unsplash.com/photo-1516409590654-e8d51fc2d25c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&fit=crop";
const IMG_BOARDS = "https://www.yspaper.com/assets/_/rs:fill:::1:0/w:800/h:1130/L2FwaS95b3VuZ3N1bi9vcmlnaW5hbHMvMThlMzI5ZDEtYmFhYy00Y2YyLTgyYzItM2UyZjVjNDNlZTI2LmpwZw";
const IMG_GLOSSY = "https://images.unsplash.com/photo-1621944192383-34519b64a747?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&fit=crop";
const IMG_COPIER = "https://images.unsplash.com/photo-1633415565473-5208a5da0d16?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&fit=crop";
const IMG_BAG = "https://images.unsplash.com/photo-1534452203293-494d7ddbf7e0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&fit=crop";
const IMG_KRAFT = "https://images.unsplash.com/photo-1643592528154-299d3fc210de?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&fit=crop";
const IMG_TISSUE = "https://images.unsplash.com/photo-1631524254770-03abe3f42a0d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&fit=crop";
const IMG_POSTER = "https://images.unsplash.com/photo-1508161773455-3ada8ed2bbec?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&fit=crop";
const IMG_FOODWRAP = "https://images.unsplash.com/photo-1608790824533-d5a7d1aea7cb?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&fit=crop";

export const PRODUCT_SEGMENTS = [
  { id: "printing", title: "Printing & Publishing Paper", note: "Dependable printing grades for books, magazines and commercial print." },
  { id: "board", title: "FBB / Packaging Board", note: "Rigid, print-ready folding box board for cartons and premium packaging." },
  { id: "specialty", title: "Specialty Paper", note: "Kraft, food-grade, tissue, poster and grease-resistant grades sourced to your spec." },
];

export const PRODUCTS = [
  {
    slug: "maplitho-paper",
    segment: "printing",
    name: "Maplitho Paper",
    tag: "Uncoated Printing Paper",
    short: "Premium uncoated woodfree printing paper with excellent surface, brightness and consistent runnability for high-volume print.",
    image: IMG_SHEETS,
    applications: ["Books & textbooks", "Notebooks & registers", "Brochures & leaflets", "Commercial offset printing"],
    relevance: "Ideal for publishers and commercial printers needing dependable brightness and print fidelity across large runs.",
    sourcing: "Available in a wide range of GSM and sizes, with consistent stock backed by strong mill relationships.",
  },
  {
    slug: "c2s-art-paper",
    segment: "printing",
    name: "C2S Art Paper",
    tag: "Coated Two Sides",
    short: "Coated two-side art paper delivering a smooth, glossy finish and outstanding ink holdout for premium print.",
    image: IMG_GLOSSY,
    applications: ["Magazines & catalogues", "Premium brochures", "Annual reports", "Marketing collateral"],
    relevance: "The go-to choice for marketing teams and printers wanting rich colour and a high-end tactile finish.",
    sourcing: "Stocked in gloss and matt finishes across popular GSM ranges for both sheets and reels.",
  },
  {
    slug: "copier-paper-a4",
    segment: "printing",
    name: "Copier Paper (A4)",
    tag: "Office · A4 / Copier",
    short: "Bright, jam-free multipurpose copier paper in A4 and standard office sizes for everyday printing, copying and documentation.",
    image: IMG_COPIER,
    applications: ["Photocopying & laser printing", "Office documentation", "Inkjet printing", "Everyday business use"],
    relevance: "For offices, institutions, stationers and resellers needing dependable, smooth-running copier paper in bulk.",
    sourcing: "Available in popular GSM (typically 70–80 GSM) in A4 and A3, packed in reams and cartons for easy distribution.",
  },
  {
    slug: "fbb-board",
    segment: "board",
    name: "FBB Board",
    tag: "Folding Box Board (FBB)",
    short: "Multi-layer folding box board engineered for rigidity, clean creasing and vibrant print reproduction in packaging.",
    image: IMG_BOARDS,
    applications: ["Cartons & packaging", "Pharma & FMCG boxes", "Retail & gift packaging", "Display cards"],
    relevance: "Preferred by packaging companies and converters for its stiffness-to-weight ratio and finishing quality.",
    sourcing: "Multiple grammages available with reliable lead times for bulk packaging requirements.",
  },
  {
    slug: "carry-bag-paper",
    segment: "specialty",
    name: "Carry Bag Paper",
    tag: "Kraft · Carry Bag Grade",
    short: "Strong kraft carry bag paper (available in 30 BF and other burst factors) built for durable, eco-friendly paper bags.",
    image: IMG_BAG,
    applications: ["Paper carry & shopping bags", "Grocery & retail bags", "Garment & takeaway bags", "Bag converting"],
    relevance: "Made for bag manufacturers and retailers moving from plastic to sturdy, sustainable paper bags.",
    sourcing: "Available in various GSM, burst factors and shades with dependable strength.",
  },
  {
    slug: "virgin-kraft-food-grade",
    segment: "specialty",
    name: "Virgin Kraft Paper (Food Grade)",
    tag: "Food Grade Kraft",
    short: "Clean, virgin-fibre kraft paper produced to food-contact standards for safe food packaging and wrapping.",
    image: IMG_KRAFT,
    applications: ["Food wrapping", "Bakery & takeaway packaging", "Pouches & liners", "Hygienic packaging"],
    relevance: "For food brands and packaging converters that need safe, virgin food-grade paper.",
    sourcing: "Virgin-pulp based, available across the GSM range your application demands.",
  },
  {
    slug: "tissue-paper",
    segment: "specialty",
    name: "Tissue Paper",
    tag: "Tissue",
    short: "Soft, absorbent tissue paper for hygiene, wrapping and converting applications.",
    image: IMG_TISSUE,
    applications: ["Napkins & facial tissue", "Toilet tissue converting", "Wrapping & interleaving", "Hygiene products"],
    relevance: "For tissue converters and packaging users needing consistent, quality base tissue.",
    sourcing: "Multiple grades and GSM available to match your converting line.",
  },
  {
    slug: "poster-paper",
    segment: "specialty",
    name: "Poster Paper",
    tag: "Poster Grade",
    short: "Bright, high-opacity poster paper engineered for bold colour and crisp reproduction on large-format and wall posters.",
    image: IMG_POSTER,
    applications: ["Posters & wall bills", "Advertising & campaigns", "Point-of-sale displays", "Large-format print"],
    relevance: "For printers and advertisers producing eye-catching posters that hold their colour.",
    sourcing: "Available in popular GSM in both sheets and reels.",
  },
  {
    slug: "ogr-paper",
    segment: "specialty",
    name: "OGR Paper",
    tag: "Oil & Grease Resistance",
    short: "Grease-proof OGR (Oil & Grease Resistance) paper that stops oils and fats soaking through — ideal for food service.",
    image: IMG_FOODWRAP,
    applications: ["Burger & sandwich wraps", "Fried & oily food packaging", "Bakery liners", "Food-service sheets"],
    relevance: "For food brands, QSRs and converters needing reliable grease and oil resistance.",
    sourcing: "Available in food-safe grades and GSM to suit your packaging line.",
  },
];

export const MILLS = [
  {
    name: "Seshasayee Paper and Boards Limited",
    focus: "Paper & Board",
    note: "A trusted source for quality paper and board grades supporting a wide range of commercial and packaging needs.",
  },
  {
    name: "Century Pulp and Paper",
    focus: "Writing, Printing & Tissue",
    note: "A well-established name known for consistent quality across writing, printing and specialty paper grades.",
  },
  {
    name: "Orient Paper",
    focus: "Writing & Printing Paper",
    note: "A long-standing manufacturer offering dependable writing and printing paper for everyday commercial use.",
  },
  {
    name: "Shreyans Paper",
    focus: "Paper & Board",
    note: "A reliable partner mill supporting steady availability across popular paper and board requirements.",
  },
];

export const WHY = [
  { title: "Decades of trade experience", body: "Half a century in the paper trade means we understand grades, availability, pricing and what your print or packaging job truly needs." },
  { title: "Strong mill relationships", body: "Direct associations with established mills give us dependable access to quality-backed stock and better sourcing strength." },
  { title: "Reliable, consistent supply", body: "Consistency is our promise. We plan availability so your production lines and print runs never wait on paper." },
  { title: "Personalised customer support", body: "You deal with people who know your business — not a call centre. Responsive, relationship-driven service every time." },
  { title: "Deep market understanding", body: "We read the market so you don't have to, guiding you on the right grade, timing and value for your requirement." },
  { title: "Long-term business values", body: "Trust, integrity and consistency have carried us through three generations — and they shape every order we handle." },
];

export const TIMELINE = [
  { year: "1970", title: "The foundation", person: "Meghraj Jain", body: "Meghraj Jain establishes the business, laying a foundation of trust, fair dealing and deep knowledge of the paper trade." },
  { year: "2nd Gen", title: "Growing the network", person: "Dinesh Jain", body: "Dinesh Jain carries the business forward, deepening mill relationships and expanding the range of paper and board grades served." },
  { year: "Today", title: "Heritage meets modern service", person: "Dinesh & Milan Jain", body: "The second and third generations work together — Dinesh Jain's experience with Milan Jain's modern, responsive approach to serving trade buyers." },
];

export const INDUSTRIES = [
  { name: "Printing", body: "Offset and commercial printers who depend on consistent brightness, runnability and on-time supply." },
  { name: "Publishing", body: "Book and magazine publishers requiring reliable printing paper across large, repeat volumes." },
  { name: "Packaging", body: "Carton makers and packaging companies needing strong, print-ready board grades." },
  { name: "Commercial Stationery", body: "Manufacturers of notebooks, registers and office stationery products." },
  { name: "Marketing Materials", body: "Agencies and brands producing premium brochures, catalogues and campaigns." },
  { name: "Corporate Print", body: "Corporate procurement teams sourcing paper for reports, communications and print needs." },
  { name: "Trade Resellers", body: "Dealers and distributors looking for a dependable upstream sourcing partner." },
];

export const SUSTAINABILITY_POINTS = [
  { title: "Renewable by nature", body: "Paper is made from a renewable resource. Responsibly managed forestry means more trees are planted than harvested." },
  { title: "Recyclable & biodegradable", body: "Paper and board are among the most recycled materials in the world and break down naturally, unlike many alternatives." },
  { title: "A smarter choice for packaging", body: "As brands move away from plastics, paper-based packaging offers a practical, eco-conscious and consumer-preferred alternative." },
  { title: "Sourced with responsibility", body: "We favour mills and grades that reflect responsible sourcing, helping your business meet its own sustainability goals." },
];

export const PAPER_ADVANTAGES = [
  "Versatile across print, packaging and stationery",
  "Excellent print surface and colour reproduction",
  "Cost-effective for both short and long runs",
  "Trusted, tactile and premium in feel",
];

export const FAQS = [
  { q: "What types of paper products do you supply?", a: "We supply Maplitho paper, copier (A4) paper, C2S art paper, FBB (folding box) board, and a full range of specialty paper — including carry bag paper, virgin food-grade kraft paper, tissue paper, poster paper and OGR (oil & grease resistance) paper — for printing, publishing and packaging applications." },
  { q: "Which mills do you deal with?", a: "We are associated with established mills including Seshasayee Paper and Boards Limited, Century Pulp and Paper, Orient Paper and Shreyans Paper, giving us quality-backed, dependable sourcing." },
  { q: "Do you handle bulk enquiries?", a: "Yes. Bulk and repeat supply for printers, publishers, packaging companies and dealers is at the core of what we do. Share your requirement and we'll advise on availability and value." },
  { q: "How can I choose the right paper for my requirement?", a: "Tell us your application, GSM, size and volume — our decades of market experience help us recommend the right grade for your print or packaging job." },
  { q: "Do you supply paper for printing and packaging applications?", a: "Absolutely. Our portfolio covers commercial printing, publishing, packaging, stationery and specialty applications." },
  { q: "How can I contact Mysore Paper for an enquiry?", a: "Call or WhatsApp Milan Jain at +91 88672 59550, email mysorepaper@gmail.com, or visit us at Sultanpet Circle, Bangalore. We respond quickly to trade enquiries." },
];
